export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
      stroke="#717680"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.79514 17.5C8.38275 18.0186 9.15462 18.3333 10 18.3333C10.8454 18.3333 11.6172 18.0186 12.2048 17.5M15 6.66667C15 5.34059 14.4732 4.06882 13.5355 3.13113C12.5978 2.19345 11.3261 1.66667 10 1.66667C8.67391 1.66667 7.40214 2.19345 6.46446 3.13113C5.52678 4.06882 5 5.34059 5 6.66667C5 9.24182 4.35039 11.005 3.62472 12.1712C3.0126 13.1549 2.70654 13.6468 2.71777 13.784C2.73019 13.9359 2.76238 13.9938 2.88481 14.0847C2.99538 14.1667 3.49382 14.1667 4.49071 14.1667H15.5093C16.5062 14.1667 17.0046 14.1667 17.1152 14.0847C17.2376 13.9938 17.2698 13.9359 17.2822 13.784C17.2934 13.6468 16.9874 13.1549 16.3753 12.1712C15.6496 11.005 15 9.24182 15 6.66667Z"
      stroke="#414651"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="#414651"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.98356 7.37769C7.56356 8.5857 8.35422 9.7179 9.35553 10.7192C10.3568 11.7205 11.4891 12.5112 12.6971 13.0912C12.801 13.1411 12.8529 13.166 12.9187 13.1852C13.1523 13.2533 13.4392 13.2044 13.637 13.0627C13.6927 13.0228 13.7403 12.9752 13.8356 12.8799C14.1269 12.5886 14.2726 12.4429 14.4191 12.3477C14.9715 11.9885 15.6837 11.9885 16.2361 12.3477C16.3825 12.4429 16.5282 12.5886 16.8196 12.8799L16.9819 13.0423C17.4248 13.4852 17.6462 13.7066 17.7665 13.9445C18.0058 14.4174 18.0058 14.976 17.7665 15.4489C17.6462 15.6868 17.4248 15.9082 16.9819 16.3511L16.8506 16.4824C16.4092 16.9238 16.1886 17.1445 15.8885 17.313C15.5556 17.5 15.0385 17.6345 14.6567 17.6333C14.3126 17.6323 14.0774 17.5656 13.607 17.4321C11.0792 16.7146 8.69387 15.3609 6.70388 13.3709C4.7139 11.3809 3.36017 8.99559 2.6427 6.46776C2.50919 5.99738 2.44244 5.7622 2.44141 5.41808C2.44028 5.03622 2.57475 4.51915 2.76176 4.18623C2.9303 3.8862 3.15098 3.66552 3.59233 3.22417L3.72369 3.09281C4.16656 2.64994 4.388 2.42851 4.62581 2.30822C5.09878 2.06899 5.65734 2.06899 6.1303 2.30822C6.36812 2.42851 6.58955 2.64994 7.03242 3.09281L7.19481 3.2552C7.48615 3.54654 7.63182 3.69221 7.72706 3.83869C8.08622 4.3911 8.08622 5.10325 7.72706 5.65566C7.63182 5.80214 7.48615 5.94781 7.19481 6.23915C7.09955 6.33441 7.05192 6.38204 7.01206 6.43771C6.87038 6.63557 6.82146 6.92245 6.88957 7.15608C6.90873 7.22182 6.93367 7.27378 6.98356 7.37769Z"
      stroke="#535862"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MailIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66666 5.83333L8.47076 10.5962C9.02173 10.9819 9.29722 11.1747 9.59688 11.2494C9.86157 11.3154 10.1384 11.3154 10.4031 11.2494C10.7028 11.1747 10.9782 10.9819 11.5292 10.5962L18.3333 5.83333M5.66666 16.6667H14.3333C15.7335 16.6667 16.4335 16.6667 16.9683 16.3942C17.4387 16.1545 17.8212 15.772 18.0608 15.3016C18.3333 14.7669 18.3333 14.0668 18.3333 12.6667V7.33333C18.3333 5.9332 18.3333 5.23313 18.0608 4.69835C17.8212 4.22795 17.4387 3.8455 16.9683 3.60581C16.4335 3.33333 15.7335 3.33333 14.3333 3.33333H5.66666C4.26653 3.33333 3.56646 3.33333 3.03168 3.60581C2.56128 3.8455 2.17882 4.22795 1.93914 4.69835C1.66666 5.23313 1.66666 5.9332 1.66666 7.33333V12.6667C1.66666 14.0668 1.66666 14.7669 1.93914 15.3016C2.17882 15.772 2.56128 16.1545 3.03168 16.3942C3.56646 16.6667 4.26653 16.6667 5.66666 16.6667Z"
      stroke="#535862"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessageIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 7.08333H10M5.83333 10H12.5M8.06979 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V16.9463C2.5 17.3903 2.5 17.6123 2.59102 17.7263C2.67019 17.8255 2.79022 17.8832 2.91712 17.8831C3.06302 17.8829 3.23639 17.7442 3.58313 17.4668L5.57101 15.8765C5.9771 15.5517 6.18014 15.3892 6.40624 15.2737C6.60683 15.1712 6.82036 15.0963 7.04101 15.051C7.28972 15 7.54975 15 8.06979 15Z"
      stroke="#414651"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" fill="#1275B1" />
    <path
      d="M9.46392 7.26911C9.46392 7.97002 8.85639 8.53822 8.10696 8.53822C7.35753 8.53822 6.75 7.97002 6.75 7.26911C6.75 6.5682 7.35753 6 8.10696 6C8.85639 6 9.46392 6.5682 9.46392 7.26911Z"
      fill="white"
    />
    <path d="M6.93557 9.47107H9.25515V16.5H6.93557V9.47107Z" fill="white" />
    <path
      d="M12.9897 9.47107H10.6701V16.5H12.9897C12.9897 16.5 12.9897 14.2872 12.9897 12.9036C12.9897 12.0732 13.2732 11.2392 14.4046 11.2392C15.6833 11.2392 15.6756 12.3259 15.6696 13.1678C15.6618 14.2683 15.6804 15.3914 15.6804 16.5H18V12.7903C17.9804 10.4215 17.3631 9.33006 15.3325 9.33006C14.1265 9.33006 13.379 9.87754 12.9897 10.3729V9.47107Z"
      fill="white"
    />
  </svg>
);

export const GithubIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.5C6.19875 1.5 1.5 6.19875 1.5 12C1.5 16.6462 4.50562 20.5706 8.67937 21.9619C9.20437 22.0538 9.40125 21.7388 9.40125 21.4631C9.40125 21.2138 9.38813 20.3869 9.38813 19.5075C6.75 19.9931 6.0675 18.8644 5.8575 18.2737C5.73937 17.9719 5.2275 17.04 4.78125 16.7906C4.41375 16.5937 3.88875 16.1081 4.76813 16.095C5.595 16.0819 6.18563 16.8562 6.3825 17.1712C7.3275 18.7594 8.83688 18.3131 9.44063 18.0375C9.5325 17.355 9.80812 16.8956 10.11 16.6331C7.77375 16.3706 5.3325 15.465 5.3325 11.4487C5.3325 10.3069 5.73938 9.36187 6.40875 8.62687C6.30375 8.36437 5.93625 7.28812 6.51375 5.84437C6.51375 5.84437 7.39313 5.56875 9.40125 6.92063C10.2412 6.68438 11.1338 6.56625 12.0263 6.56625C12.9188 6.56625 13.8113 6.68438 14.6513 6.92063C16.6594 5.55563 17.5388 5.84437 17.5388 5.84437C18.1163 7.28812 17.7488 8.36437 17.6438 8.62687C18.3131 9.36187 18.72 10.2937 18.72 11.4487C18.72 15.4781 16.2656 16.3706 13.9294 16.6331C14.31 16.9612 14.6381 17.5913 14.6381 18.5756C14.6381 19.98 14.625 21.1088 14.625 21.4631C14.625 21.7388 14.8219 22.0669 15.3469 21.9619C17.4313 21.2582 19.2426 19.9185 20.5258 18.1315C21.809 16.3445 22.4994 14.2 22.5 12C22.5 6.19875 17.8013 1.5 12 1.5Z"
      fill="black"
    />
  </svg>
);
